import { graphql } from "@/graphql/codegen"

graphql(`
  mutation CreateGlTransaction($input: GlTransactionInsertInput!) {
    glTransaction {
      create(input: $input) {
        ... on GlTransactionCreateSuccess {
          glTransactions {
            glTransactionId
            transactionDate
            as400SyncStatus
            referenceNumber
          }
        }
        ... on GlTransactionFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation UpdateGlTransaction($input: GlTransactionUpdateInput!) {
    glTransaction {
      update(input: $input) {
        ... on GlTransactionUpdateSuccess {
          glTransaction {
            glTransactionId
            description
            note
            transactionDate
            status
            recurringId
            referenceNumber
          }
        }
        ... on GlTransactionFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation CancelGlTransaction($input: GlTransactionCancelInput!) {
    glTransaction {
      cancel(input: $input) {
        ... on GlTransactionCancelSuccess {
          glTransaction {
            glTransactionId
            status
            referenceNumber
          }
        }
        ... on GlTransactionFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation ReverseGlTransaction($input: GlTransactionReverseInput!) {
    glTransaction {
      reverse(input: $input) {
        ... on GlTransactionReverseSuccess {
          glTransaction {
            glTransactionId
            status
            reason
            referenceNumber
          }
        }
        ... on GlTransactionFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
